import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconSuccess: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = "#16B364",
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0001 1.0415C5.06008 1.0415 1.04175 5.06067 1.04175 9.99984C1.04175 14.939 5.06008 18.9582 10.0001 18.9582C14.9401 18.9582 18.9584 14.939 18.9584 9.99984C18.9584 5.06067 14.9401 1.0415 10.0001 1.0415ZM10.0001 17.7082C5.74925 17.7082 2.29175 14.2507 2.29175 9.99984C2.29175 5.749 5.74925 2.2915 10.0001 2.2915C14.2509 2.2915 17.7084 5.749 17.7084 9.99984C17.7084 14.2507 14.2509 17.7082 10.0001 17.7082ZM13.3584 7.61316C13.6026 7.85733 13.6026 8.25319 13.3584 8.49736L9.46925 12.3865C9.34759 12.5082 9.18759 12.5698 9.02759 12.5698C8.86759 12.5698 8.70759 12.509 8.58592 12.3865L6.64175 10.4423C6.39758 10.1982 6.39758 9.80231 6.64175 9.55815C6.88592 9.31398 7.28175 9.31398 7.52592 9.55815L9.02843 11.0607L12.4751 7.61402C12.7192 7.36986 13.1142 7.36983 13.3584 7.61316Z"
      fill={color}
    />
  </svg>
);

export default IconSuccess;
